import { CreateSingleton } from "@pdfking/tfunc"
import has_dom from "@pdfking/workflow/utils/has_dom"

export default CreateSingleton(
  (): boolean =>
    has_dom() &&
    !(
      navigator.maxTouchPoints > 0 ||
      // @ts-expect-error msMaxTouchPoints is deprecated IE/Edge property not in modern types
      navigator.msMaxTouchPoints > 0 ||
      "ontouchstart" in window
    )
)
